import React, { Fragment } from "react";
import { Link } from "react-router-dom";
import BackgroundTheme from "../components/Intro/BackgroundTheme";
function Home({ history }) {
  return (
    <Fragment>
      <h1 className="text-3xl font-Cairo font-bold">تطبيق تخطيط </h1>
      <h3 className="text-gray-600 text-lg mt-5 font-Cairo font-medium px-24 text-center">
        هو عبارة تطبيق يسمح لك باختيار قوالب لتنظيم مهامك مثل (تقويم شهري , جدول
        يومي , جدول اسبوعي وغيره ...) عن طريق واجهة رسومية تسمح لك بتحميله و .
        .طباعته في مكتبك
      </h3>
      <div className="flex-1 flex justify-around w-full items-center">
        <div>
          <div className="border-blue-600 border-2  rounded-full h-40 shadow-md w-40 flex justify-center items-center">
            <div className="fa fa-user text-4xl text-blue-600"></div>
          </div>
          <div className=" text-center px-5 p-1 rounded-full text-sm bg-gray-200 shadow-md mt-2">
            إختر القالب
          </div>
        </div>
        <div>
          <div className="border-blue-600 border-2  rounded-full h-40 shadow-md w-40 flex justify-center items-center">
            <div className="fa fa-pencil-ruler text-4xl text-blue-600"></div>
          </div>
          <div className=" text-center px-5 p-1 rounded-full text-sm bg-gray-200 shadow-md mt-2">
            عدل عليه{" "}
          </div>
        </div>
        <div>
          <div className="border-blue-600 border-2  rounded-full h-40 shadow-md w-40 flex justify-center items-center">
            <div className="fa fa-file-alt text-4xl text-blue-600"></div>
          </div>
          <div className=" text-center px-5 p-1 rounded-full text-sm bg-gray-200 shadow-md mt-2">
            احفظه كا ملف
          </div>
        </div>
        <div>
          <div className="border-blue-600 border-2  rounded-full h-40 shadow-md w-40 flex justify-center items-center">
            <div className="fa fa-print text-4xl text-blue-600"></div>
          </div>
          <div className=" text-center px-5 p-1 rounded-full text-sm bg-gray-200 shadow-md mt-2">
            اطبعه وشاركه
          </div>
        </div>
      </div>
      <button
        onClick={() => history.push("/template")}
        className="bg-blue-500 cursor-pointer px-10 py-2 text-white rounded shadow-md hover:bg-blue-600"
      >
        قم بتجربته الآن{" "}
      </button>
    </Fragment>
  );
}

export default BackgroundTheme(Home);
